/* eslint-disable no-unused-vars */
import { ReactElement, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'react-bootstrap';
import {
  Table, Search, Button, SplitButtonWithIcon,
} from '../../../components';
import { Permissao, Pesquisa, Aplicacao } from '../../../@types/exports';

interface Props {
  permissoes: Permissao[];
  pesquisa: (x: Pesquisa) => void;
  setEditarItem: (a: any) => void;
  removerItem: (a: Permissao) => void;
}
const Texto = (textoToReplace: any) => {
  const { t } = useTranslation();
  return (
    t(`permissoes.${textoToReplace}`)
  );
};

const GridPermissoes = ({
  permissoes, pesquisa, setEditarItem, removerItem,
}: Props): ReactElement => (
  <div className="card shadow mb-4">
    <div className="card-body">
      <div className="table-responsive" style={{ overflowX: 'hidden' }}>
        <div className="dataTables_wrapper dt-bootstrap4">
          <Search
            show={Texto('show')}
            todos={Texto('todos')}
            searchTag={Texto('searchTag')}
            pesquisa={pesquisa}
            placeholderSearch={Texto('nome')}
            componentRight={(
              <SplitButtonWithIcon
                label={Texto('novoPerfil')}
                dataTarget="modal-cadastro-permissao"
                icon="plus"
                onClick={() => setEditarItem(undefined)}
              />
            )}
          />
          <br />
          <Row>
            <Col sm={12}>
              <Table
                empty={!permissoes.length}
                th={[
                  Texto('nome'),
                  Texto('aplicacoes'),
                  Texto('opcoes'),
                ]}
                td={permissoes.map((permissao) => (
                  <tr key={permissao.id}>
                    <td>{permissao.name}</td>
                    <td>
                      {permissao.aplicacoes.map((aplicacao: Aplicacao, i: number) => (
                        aplicacao ? i <= 2 && (
                          <Fragment key={`${aplicacao.id}-${permissao.id}`}>
                            <span className="badge badge-info">{aplicacao.nome}</span>
                            &nbsp;
                          </Fragment>
                        ) : ''
                      ))}

                      {permissao.aplicacoes.length > 3 && (
                        <span className="badge badge-dark">
                          <span className="symbol-label font-weight-bold">
                            {`${Number(permissao.aplicacoes.length) - 3}+`}
                          </span>
                        </span>
                      )}
                      {permissao.aplicacoes.length === 0 && (
                        <span className="badge badge-dark">
                          <span className="symbol-label font-weight-bold" />
                        </span>
                      )}
                    </td>
                    <td className="text-left">
                      <Button
                        className="btn btn-danger btn-circle btn-sm"
                        onClick={() => removerItem(permissao)}
                      >
                        <i className="fas fa-trash" />
                      </Button>
                      &nbsp;&nbsp;
                      <Button
                        className="btn btn-info btn-circle btn-sm"
                        data-toggle="modal"
                        data-target="#modal-cadastro-permissao"
                        onClick={() => setEditarItem(permissao)}
                      >
                        <i className="fas fa-pen" />
                      </Button>
                    </td>
                  </tr>
                ))}
              />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  </div>
);

export default GridPermissoes;
